import PropTypes from 'prop-types'
import { sanitizeListRestProps } from 'ra-core'
import { cloneElement, useMemo } from 'react'

import { CreateButton, ExportButton } from '../button'
import TopToolbar from '../layout/TopToolbar'

const ListActions = ({ currentSort, className, resource, filters, displayedFilters, exporter = false, filterValues, permanentFilter, hasCreate, basePath, selectedIds = [], onUnselectItems, showFilter, hasSearch, total, ...rest }) =>
  useMemo(
    () => (
      <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
        {filters &&
          cloneElement(filters, {
            resource,
            showFilter,
            hasSearch,
            displayedFilters,
            filterValues,
            context: 'button',
          })}
        {hasCreate && <CreateButton basePath={basePath} />}
        {exporter !== false && (
          <ExportButton
            disabled={total === 0}
            resource={resource}
            sort={currentSort}
            filter={{ ...filterValues, ...permanentFilter }}
          />
        )}
      </TopToolbar>
    ),
    [resource, displayedFilters, filterValues, selectedIds, filters, total]
  )

ListActions.propTypes = {
  basePath: PropTypes.string,
  className: PropTypes.string,
  currentSort: PropTypes.object,
  displayedFilters: PropTypes.object,
  exporter: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  filters: PropTypes.element,
  filterValues: PropTypes.object,
  hasCreate: PropTypes.bool,
  resource: PropTypes.string,
  onUnselectItems: PropTypes.func.isRequired,
  selectedIds: PropTypes.arrayOf(PropTypes.any),
  showFilter: PropTypes.func,
  total: PropTypes.number,
}


export default ListActions
